import React, { Component } from 'react';
import { Row, Col } from "antd";
import "./index.scss";


class index extends Component {
    render() {
        return (
            <div className="theChart">
                <Row className="title">Top 15 Vs. Total Purchase 前15位采购占总额比</Row>
                <Row>
                    <div id="purchase" style={{ height: 400, width: '100%' }} />
                </Row>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/analysisChart/purchase.js